/* eslint-disable react/jsx-pascal-case */
import React, { useState } from 'react';
import Helmet from "react-helmet";
import { Switch } from "react-router-dom";
import AdminRoute from '../../faetures/AdminRoute';
import DashboardAddBlog from '../blogs/DashboardAddBlog';
import DashboardAllBlog from '../blogs/DashboardAllBlog';
import Dashboard_home from "../home/Dashboard_home";
import Dashboard_message from '../messages/Dashboard_messages';
import DashboardOrder from '../orders/DashboardOrders';
import DashboardAddPortfolio from '../portfolio/DashboardAddPortfolio';
import DashboardAllPortfolio from '../portfolio/DashboardAllPortfolio';
import DashboardAddPricing from '../pricing/DashboardAddPricing';
import DashboardAllPricing from '../pricing/DashboardAllPricing';
import DashboardAddResume from '../resume/DashboardAddResume';
import Dashboard_users from '../users/Dashboard_users';
import Dashboard_top_header from './Dashboard_top_header';
import Sidebar from './Sidebar';
function Dashboard() {
  const [sidebarHide , setSidebarHide] =useState(false);
  const handleSidebarHideAndShow = (e) => {
      setSidebarHide(!sidebarHide)
  };

  
  return (
    <div className='dashboard-container'>
      <Helmet>
        <title>Dashboard </title>
      </Helmet>
    <div className="navbar-area">
        <Dashboard_top_header handleSidebarHideAndShow={handleSidebarHideAndShow} sidebarHide={sidebarHide}/>
    </div>
   
    <div className="dashboard-main-flex">
    <div className="dashboard-sidebar">
        <Sidebar sidebarHide={sidebarHide}  />
    </div> 
    <div className="dashboard-item">
    
       <Switch>
          
               <AdminRoute path='/admin/dashboard' component={Dashboard_home} exact />
               <AdminRoute path="/admin/dashboard/add-portfolio" component={DashboardAddPortfolio} exact/>
               <AdminRoute path="/admin/dashboard/all-portfolio/:currentPage?" component={DashboardAllPortfolio} exact />
               <AdminRoute path="/admin/dashboard/add-blog" component={DashboardAddBlog } exact  />
               <AdminRoute path="/admin/dashboard/all-blog/:currentPage?" component={DashboardAllBlog}  exact/>
               <AdminRoute path="/admin/dashboard/add-pricing" component={DashboardAddPricing } exact />
               <AdminRoute path="/admin/dashboard/all-pricing/:currentPage?" component={DashboardAllPricing} exact />
               <AdminRoute path="/admin/dashboard/all-orders/:currentPage?" component={DashboardOrder} exact />
               <AdminRoute path="/admin/dashboard/all-users/:currentPage?" component={Dashboard_users} exact />
               <AdminRoute path="/admin/dashboard/all-messages/:currentPage?" component={ Dashboard_message} exact /> 
               <AdminRoute path="/admin/dashboard/add-resume" component={ DashboardAddResume} exact /> 
        </Switch>
          
    </div>
    </div>
    
</div>
  
  )
}

export default Dashboard